const formatter = new Intl.NumberFormat();

export const numberFormatter = (value: number) => {
  return formatter.format(value);
};
